import { useTranslation } from 'react-i18next'

const RelativeStart = (props) => {
  const { t } = useTranslation()
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1920 1080"
      role="image"
      aria-labelledby="relative-start-title"
      {...props}
    >
      <title id="relative-start-title">{t('antagonists:relative:components:start')}</title>
      <path
        d="M1544.66 175.73c-4.8.69-30.06-2.7-36.17 6.68-6.11 9.39-2.5 15.42-5.01 24.46-2.52 9.04 1.37 17.07.29 22.98s5.75 19.82 5.75 19.82l70.56 3.96s3.11-16.12 4.9-24.12c1.8-8 5.8-14.16 2.93-21.81-2.87-7.65-4.72-11.56-9.04-18.87-4.31-7.3-10.16-17.06-18.79-17.75-8.62-.7-10.63 3.97-15.42 4.66Z"
        style={{
          fill: '#afb1b4',
        }}
      />
      <path
        d="M1547.63 204.12c-8.41.32-13.68 4.88-21.94 4.88s-15.45 3.48-14.73 9.73c.72 6.26 2.48 23.81-.81 24.65-3.29.84-3.86-15.26-8.17-14.57-4.31.7-3.95 7.65-3.23 15.99.72 8.34 1.33 17.19 4.21 17.19 2.87 0 5.5-2.24 5.5-2.24s-2.08 17.3 2.59 23.91c4.67 6.61 11.78 15.73 19.69 18.51 7.91 2.78 10.19-.31 17.09-2.49 6.8-2.15 15.38-8.6 20.03-16.48 3.53-5.98 3.85-18.93 6-19.62 2.16-.7 4.31 2.78 7.55-1.39 3.23-4.17 5.03-9.04 6.47-13.21 1.44-4.17 4.31-13.56.36-14.6-3.95-1.04-9.7 7.3-10.42 9.39-.72 2.09-2.87 3.48-3.23.7s2.52-8.69.72-13.56c-1.8-4.87-2.52-5.21-1.8-13.21s-10.42-8.69-15.09-9.39-2.35-4.5-10.76-4.18Z"
        style={{
          fill: '#dfbe84',
        }}
      />
      <path
        d="m1546.7 239.06-1.01 3.24s8.61-1.08 14.42 1.08c5.81 2.16 7.82 2.59 7.82 2.59l1.23-2.7s-7.74-6.46-14.12-7.11c-6.37-.65-8.35 2.89-8.35 2.89ZM1534.47 241.06l1.01-2.49s-.85-5.25-9.37-5.7c-8.03-.43-11.71 3.91-11.71 3.91l.69 2.41s7.98-1.15 10.89-1.06c3.35.11 8.49 2.92 8.49 2.92Z"
        style={{
          fill: '#afb1b4',
        }}
      />
      <path
        d="M1510.1 250.72s7.51 31.69 1.96 40.65c-5.55 8.95-39.91 13.08-39.91 13.08s-10.18 39.1-9.26 37.91c.93-1.19 150 33.47 148.46 33.47s-2.92-65.59-2.92-65.59-31.66-12.52-38.45-18.78-1.57-24.31-1.57-29.98v-14.63l-58.31 3.88Z"
        style={{
          fill: '#dfbe84',
        }}
      />
      <path
        d="M1531.03 274.73s.16 2.51.32 4.07c.16 1.57 1.13 4.39 1.13 4.39l5.34-.47s.65-1.88.97-4.07c.32-2.19-.16-4.39-.16-4.39l-7.61.47Z"
        style={{
          fill: 'none',
        }}
      />
      <path
        d="M1525.4 280.45c.85 1.46 1.78.77 3.28 2.12 1.5 1.34 2.08 3.66 7.63 3.78 5.55.12 10.53-2.81 12.26-2.44 1.73.37 2.2.13 2.43-.97.23-1.1-5.44-5.74-8.68-5.5-3.24.24-3.7 1.22-4.51 1.22s-1.5-2.08-4.51-1.34c-3.01.73-8.84 1.55-7.91 3.13Z"
        style={{
          fill: '#f2974a',
        }}
      />
      <path
        d="M1526.12 242.65c-1.85-.52-3.5.37-3.93 2.2-.44 1.83.53 2.9 2.16 3.47 1.92.67 3.37-.2 4.01-2.04.45-1.3-.34-3.09-2.24-3.63Z"
        style={{
          fill: '#6b5738',
        }}
      />
      <path
        style={{
          fill: '#6b5738',
        }}
        d="m1521.27 242.05 9.15 3.03 1.71-2.98-10.06-2.5-.8 2.45zM1555.76 246.43c1.92.09 3.2 1.45 3.04 3.32-.16 1.88-1.42 2.58-3.14 2.61-2.04.03-3.14-1.25-3.17-3.2-.02-1.37 1.29-2.83 3.26-2.74Z"
      />
      <path
        style={{
          fill: '#6b5738',
        }}
        d="m1560.65 246.55-9.2.86-.69-3.36 9.9-.08-.01 2.58zM1590.11 914.58s.21 24.53-.63 37.12c-.84 12.58-2.93 31.03-2.93 31.03s7.54 4.82 7.96 8.6c.42 3.77-1.05 12.37-1.05 12.37s5.86 5.03 13.82 5.03 30.15.21 32.24-.21c2.09-.42 4.61-5.87 4.61-5.87s-.21-10.27-5.44-20.34-6.7-10.9-7.54-16.78c-.84-5.87-2.72-17.61-2.3-24.32.42-6.71-.42-27.05-.42-27.05l-38.32.42ZM1465.74 913.11c-.42.63-1.26 26.84-3.14 34.18-1.88 7.34-6.07 22.65-10.05 26-3.98 3.36-13.82 11.74-14.03 17.4-.21 5.66-.84 17.4-.84 17.4s9.21.42 17.8.84c8.58.42 15.7.42 23.66-2.1 7.96-2.52 10.89-6.08 10.89-6.08l.21-9.44 17.59-8.18s-.42-3.56-1.05-14.05-5.86-20.55-5.44-23.7c.42-3.15 1.88-7.34 2.93-15.31 1.05-7.97.42-18.87.42-18.87l-38.95 1.89Z"
      />
      <path
        d="M1600.37 963.16s8.73-3.36 15.05-3.23c6.32.13 13.17 2.02 13.17 2.02l.13 2.83s-6.05-2.29-14.38-1.48c-8.33.81-12.9 3.23-12.9 3.23l-1.07-3.36ZM1599.99 956.4s8.89-2.92 15.19-2.47c6.3.45 13.05 2.67 13.05 2.67v2.83s-5.93-2.59-14.29-2.2c-8.36.39-13.04 2.58-13.04 2.58l-.91-3.41ZM1598.11 949.68s9.32-3.11 16.02-2.88c6.7.23 13.94 2.17 13.94 2.17l.1 2.74s-6.38-2.31-15.23-1.67c-8.85.64-13.73 2.91-13.73 2.91l-1.09-3.27ZM1597.3 941.88s9.32-3.11 16.02-2.88c6.7.23 13.94 2.17 13.94 2.17l.1 2.74s-6.38-2.31-15.23-1.67c-8.85.64-13.73 2.91-13.73 2.91l-1.09-3.27ZM1596.09 934.21s9.32-3.11 16.02-2.88c6.7.23 13.94 2.17 13.94 2.17l.1 2.74s-6.38-2.31-15.23-1.67c-8.85.64-13.73 2.91-13.73 2.91l-1.09-3.27ZM1490.13 960.61s-8.6-3.43-15.08-3.07c-6.63.36-14.32 2.76-14.32 2.76l-.72 3.34s7.02-2.94 15.76-2.33c8.58.6 13.11 3.19 13.11 3.19l1.25-3.87ZM1490.78 953.29s-8.5-2.83-14.79-2.23c-6.45.61-13.85 3.18-13.85 3.18l-.53 3.15s6.71-3.05 15.26-2.85c8.36.19 12.88 2.41 12.88 2.41l1.03-3.65ZM1492.79 946.47s-8.6-2.91-15.01-2.61c-6.56.3-14.1 2.33-14.1 2.33l-.58 2.82s6.85-2.48 15.52-1.96c8.5.51 13.05 2.7 13.05 2.7l1.12-3.27ZM1493.72 939.11s-8.29-2.79-14.45-2.59c-6.3.21-13.52 2.01-13.52 2.01l-.53 2.61s6.54-2.23 14.87-1.66c8.17.56 12.55 2.64 12.55 2.64l1.07-3.02ZM1494.93 932.39s-8-2.69-13.93-2.56c-6.05.13-12.97 1.74-12.97 1.74l-.48 2.43s6.26-2.01 14.27-1.39c7.86.61 12.09 2.59 12.09 2.59l1.01-2.81Z"
        style={{
          fill: '#1c3628',
        }}
      />
      <path
        d="M1466.67 559.4s-7.47 110.65-6.41 144.32c1.07 33.68 6.94 54.52 5.87 66.82-1.07 12.29-3.2 96.22-3.2 113.32 0 17.1-2.14 52.92-2.14 52.92s12.28 6.41 25.09 4.81c12.81-1.6 24.02-5.88 24.02-5.88s4.8-12.83 3.74-26.19c-1.07-13.36 8.01-45.44 5.87-65.21-2.13-19.78 3.2-58.26 6.4-72.16 3.2-13.9 9.61-70.02 14.94-94.61 5.34-24.59 26.15-72.16 26.15-72.16l-13.34-49.71-87 3.74Z"
        style={{
          fill: '#535b81',
        }}
      />
      <path
        d="M1542.46 579.18s21.35 104.23 24.55 149.13c3.2 44.9 4.8 48.64 5.87 57.19 1.07 8.55 4.27 90.34 8.01 110.11 3.74 19.78 6.94 48.64 6.94 48.64s8.54 1.6 20.28 2.67 23.48-3.74 23.48-3.74 4.8-13.36.53-51.31-7.47-104.23-8.01-116.53c-.53-12.29-2.67-12.83-1.07-30.47 1.6-17.64 13.34-79.65 12.28-109.04-1.07-29.4-16.01-91.4-16.01-91.4l-76.86 34.74Z"
        style={{
          fill: '#535b81',
        }}
      />
      <path
        d="M1545.98 630.79s.65.1 1.68.16"
        style={{
          fill: 'none',
          stroke: '#d4c27f',
          strokeLinecap: 'round',
          strokeMiterlimit: 10,
          strokeWidth: '1.35px',
        }}
      />
      <path
        d="M1552.78 630.66c1.93-.36 3.9-1.09 5.38-2.47"
        style={{
          fill: 'none',
          stroke: '#d4c27f',
          strokeDasharray: '0 0 3.43 5.14',
          strokeLinecap: 'round',
          strokeMiterlimit: 10,
          strokeWidth: '1.35px',
        }}
      />
      <path
        d="M1559.7 626.14c.16-.33.31-.67.43-1.05 2.46-7.55 1.23-43.9 1.23-43.9v-3.75"
        style={{
          fill: 'none',
          stroke: '#d4c27f',
          strokeDasharray: '0 0 0 0 3.43 5.14 3.43 5.14',
          strokeLinecap: 'round',
          strokeMiterlimit: 10,
          strokeWidth: '1.35px',
        }}
      />
      <path
        style={{
          fill: 'none',
          stroke: '#d4c27f',
          strokeLinecap: 'round',
          strokeMiterlimit: 10,
          strokeWidth: '1.35px',
        }}
        d="M1561.36 574.87v-1.69"
      />
      <path
        d="M1508.21 294.19s-3.44 7.03 7.59 14.63c11.04 7.6 17.59 6.22 16.55 5.87-1.03-.35 3.55 34.98 3.55 34.98l11.28-34.28s11.96.86 19.58-10.33c5.37-7.88 3.22-13.61 3.22-13.61s14.53 5.97 30.05 12.54c15.52 6.56 37.8 8.19 39.86 16.13 2.07 7.94-23.73 72.99-20.63 94.06 3.1 21.07.69 53.88 2.07 68.73 1.38 14.85 6.9 88.08 6.9 88.08s-16.21 17.96-35.18 23.83c-18.97 5.87-35.18 12.09-35.18 12.09s-14.49-38.34-14.49-37.3-4.14 41.79-4.14 41.79-23.11 6.22-55.18-12.09-40.15-26.86-40.15-26.86 15.31-52.59 17.73-82.29c2.41-29.7 3.1-84.97-3.79-105.69-6.9-20.72-21.27-61.47-10.24-69.41 11.04-7.94 27.03-10.56 35.46-13.16 10.98-3.38 25.13-7.7 25.13-7.7Z"
        style={{
          fill: '#e6f1e2',
        }}
      />
      <path
        d="M1613.56 316.15c-19.77 13.2-6.44 68.18-.23 91.67 6.21 23.49 17.79 50.65 26.41 55.83 8.62 5.18 40.35 4.78 42.42-9.73 2.07-14.51-17.03-41.13-21.86-69.11-4.83-27.98-15.12-59.78-21.32-66.69-6.21-6.91-18.18-6.81-25.42-1.97Z"
        style={{
          fill: '#e6f1e2',
        }}
      />
      <path
        d="M1621.01 551.25s-2.88 3.09-6.4 5.27c-3.52 2.18-12.29 7.32-16.59 12.12-4.3 4.8-21.17 21.37-21.17 21.37s1.32 5.96 7.94 3.48 11.91-7.12 11.91-7.12 3.14 8.78 13.9 10.77c10.75 1.99 18.2-.83 18.2-.83s4.8-6.3 7.94-13.25c3.14-6.96 8.77-21.87 8.77-21.87l-24.48-9.94Z"
        style={{
          fill: '#dfbe84',
        }}
      />
      <path
        d="M1454.17 310.82c-14.3 4.87-22.06 26.27-29.49 47.18-7.44 20.91-14.59 91.95-14.59 91.95s2.57 29.79 16.3 19.48c13.73-10.31 50.34-87.08 50.34-87.08l-22.56-71.53ZM1636.77 450.26s-4.85 44.36-8.49 62.29c-3.64 17.93-11.23 41.93-11.23 41.93s11.23 1.82 20.02 6.38c8.8 4.56 5.99 9.54 5.99 9.54l11.91-27.77s8.8-.61 12.14-17.01c3.34-16.41 14.87-50.44 14.87-58.03 0-7.6 2.12-17.32-4.25-24.61-6.37-7.29-39.14-9.11-40.96 7.29Z"
        style={{
          fill: '#e6f1e2',
        }}
      />
      <path
        d="M1405.2 376.1s-1.89-22.36-2.89-28.87c-1-6.51-6.41-26.72-6.15-29.77.26-3.05 6.83-39.84 6.83-39.84s4.69-1.33 5.59 3.75c.9 5.08-.96 27.09-.96 27.09s6.38-6.89 8.46-7.47 6.35 2.75 6.62 4.44c.27 1.68.57 2.36.57 2.36s2.32-.49 4.85 2.07c2.53 2.56.79 3.93.79 3.93s4.85-.8 5.51 3.72c.65 4.52-3.47 10.62-3.47 10.62s.49 8.54-1.84 17.65-4.05 10.67-3.09 12.99c.95 2.32-2.18 19.4-2.18 19.4s-18.49-2.21-18.63-2.08Z"
        style={{
          fill: '#dfbe84',
        }}
      />
      <path
        d="M1400.69 352.95s10.01 4.25 17.6 5.47c7.58 1.22 13.05-2.43 13.05-2.43s.61 45.27 1.82 73.22c1.21 27.95-9.1 46.18-21.24 45.88-12.14-.3-21.24-9.11-22.45-32.21-1.21-23.09-1.21-37.07 4.25-54.08 5.46-17.01 6.98-35.85 6.98-35.85Z"
        style={{
          fill: '#e6f1e2',
        }}
      />
      <path
        d="M1576.77 242.59c-1-.22-4.28-.47-5.24-.75-.96-.27-5.97-2.07-12.67-2.33-6.74-.26-10.12.69-13.28 1.21-2.04.33-6.3.18-8.86-.67-3.04-1.01-6.22-2.48-12.92-3.29-6.65-.81-11.88.18-12.88.29-.99.12-3.63.08-4.56.19-.93.11-.09 3.72.52 4 .61.28 2.31.69 2.55 1.65.23.96.96 8.22 2.08 9.7 1.13 1.47 5.76 3.01 10.48 3.67 3.87.54 9.35-.17 10.58-1.24 1.06-.92 2.24-2.58 3.58-5.36 1.38-2.85 1.77-4.82 2.47-5.15.7-.33 3.91.02 4.35.32.64.43.71 2.45 1.63 5.47.89 2.95 1.79 4.78 2.69 5.86 1.05 1.25 6.35 2.82 10.26 2.9 4.76.09 9.58-.69 10.93-1.97 1.35-1.28 3.21-8.34 3.59-9.25.38-.91 2.34-.64 3.39-.97 1.05-.33 2.29-4.06 1.3-4.28Zm-42.75 5.4c-.83 2.26-2.1 3.82-3.1 4.94-1 1.11-5.99 1.57-9.27 1.01-3.61-.61-7.14-2.09-8.11-3.07-.97-.98-1.25-3.95-1.08-6.61.16-2.66.59-4.45 1.28-5.17.81-.85 5.77-.46 10.59.23 4.48.64 9.49 2 10.51 2.93 1.03.94 0 3.47-.83 5.73Zm32.55 7.29c-1.11.81-4.59 1.54-8.25 1.57-3.32.03-8.18-1.21-8.99-2.46-.81-1.26-1.81-3-2.28-5.37-.47-2.37-1.08-5.02.08-5.79 1.16-.76 6.32-1.31 10.84-1.24 4.87.08 9.58.65 10.25 1.62.57.83.71 2.66.45 5.31-.26 2.65-1 5.54-2.11 6.35Z"
        style={{
          fill: '#272a3e',
        }}
      />
    </svg>
  )
}

export default RelativeStart
